import React from 'react';

import { TSvgIcon } from '../types';

export const BasketFilledIcon: TSvgIcon = ({ color, width = 8 }): JSX.Element => {
    return (
        <svg width={width} viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.5 16C5.4 16 4.51 16.9 4.51 18C4.51 19.1 5.4 20 6.5 20C7.6 20 8.5 19.1 8.5 18C8.5 16.9 7.6 16 6.5 16ZM0.5 1C0.5 1.55 0.95 2 1.5 2H2.5L6.1 9.59L4.75 12.03C4.02 13.37 4.98 15 6.5 15H17.5C18.05 15 18.5 14.55 18.5 14C18.5 13.45 18.05 13 17.5 13H6.5L7.6 11H15.05C15.8 11 16.46 10.59 16.8 9.97L20.38 3.48C20.75 2.82 20.27 2 19.51 2H4.71L4.04 0.57C3.88 0.22 3.52 0 3.14 0H1.5C0.95 0 0.5 0.45 0.5 1ZM16.5 16C15.4 16 14.51 16.9 14.51 18C14.51 19.1 15.4 20 16.5 20C17.6 20 18.5 19.1 18.5 18C18.5 16.9 17.6 16 16.5 16Z"
                fill={color}
            />
        </svg>
    );
};
